module.exports = __webpack_public_path__ + "static/media/b0_p15_crystal.fa92d59a.mp3";